import { Component, AfterViewInit} from '@angular/core';

@Component({
  selector: 'app-app-landing',
  templateUrl: './app-landing.component.html',
  styleUrls: ['./app-landing.component.scss']
})
export class AppLandingComponent implements AfterViewInit {

  isloading: boolean = true

  constructor() {
    document.body.style.overflowY = "hidden";
  }

  hide() {
    this.isloading = false;
    document.body.style.overflowY = "auto";
  }

  ngAfterViewInit() {
    setTimeout(() => this.hide(), 2000);
  }
}
